export default "__VITE_ASSET__23b77537__"